import React, { Component } from "react";
import { IPropsIcone } from "../../modelo/Icone";
import IconeHermesSobrescrito from "./IconeHermesSobrescrito";
import IconePeticaoSubscrito from "./IconePeticaoSubscrito";
import IconeReportSobrescrito from "./IconeReportSobrescrito";
import IconeErroSobrescrito from "./IconeErroSobrescrito";
import IconeReportVotoFuturo from "./IconeReportVotoFuturo";
import IconeAguia from "./IconeAguia";

interface IPropsIconeVoto extends IPropsIcone {
    peticao?: boolean;
    hermes?: boolean;
    votoVencido?: boolean;
    votoFuturo?: boolean;
    votoAguia?: boolean;
    erro?:boolean;
}

class IconeVoto extends Component<IPropsIconeVoto> {

    render() {

        const isAguia = !!this.props.votoAguia;
        const tamanhoVoto = isAguia ? 22 : 24;

        return (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: isAguia ? '3px' : '2px', verticalAlign: 'middle' }}>
                {this.props.hermes && <IconeHermesSobrescrito />}
                {this.props.votoVencido && <IconeReportSobrescrito />}
                {this.props.peticao && <IconePeticaoSubscrito />}
                {this.props.votoFuturo && <IconeReportVotoFuturo />}
                {this.props.votoAguia && <span style={{ display: 'inline-flex', position: 'relative', top: '-1.5px' }}><IconeAguia size={15} /></span>}
                {this.props.erro && <IconeErroSobrescrito />}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={tamanhoVoto} height={tamanhoVoto} style={{ fill: this.props.color || 'currentColor' }}>
                    <path d="M22.93606 8.447516c-.085271-.2059508-.2488665-.369546-.4548173-.4548174l-14.367815-5.951172c-.4284854-.1773776-.920392.025996-1.0979936.4548174L1.064038 16.8642712c-.0853834.2059508-.0853834.4372253 0 .643176.0852712.205951.2488665.3695463.4548174.4548175l9.64809 3.99632c.1029755.0425796.2123378.0639815.321588.0639815.1093625 0 .2186128-.0212898.3215882-.0639815l6.674465-2.764985c.2059508-.0852713.369546-.2488666.4548174-.4548174L22.935948 9.09058c.0853834-.2057266.0853834-.437113.000112-.643064zm-9.8944914 11.1817402l.8568585-2.0688085 2.0686966.8568585zm4.6667246-2.3101676l-3.9430955-1.633152c-.4283732-.1773776-.9203917.025996-1.0979935.4548175l-1.633376 3.9434318L2.938325 16.731042 8.246657 3.9159255l12.815004 5.307996z" />
                    <path d="M10.2676194 10.452455l-1.552699.6431763 1.3737526 3.316615 5.8561523-2.4263652-.6434003-1.5526986-4.3031172 1.782965" />
                </svg>
            </span>
        );
    }
}

export default IconeVoto;
